document.addEventListener("DOMContentLoaded", () => {
  const countdowns = document.querySelectorAll("[data-countdown]");

  countdowns.forEach((countdown) => {
    const target = countdown.getAttribute("data-countdown");
    if (!target) return;

    const daysNode = countdown.querySelector("[data-countdown-days]");
    const hoursNode = countdown.querySelector("[data-countdown-hours]");
    const minutesNode = countdown.querySelector("[data-countdown-minutes]");
    const secondsNode = countdown.querySelector("[data-countdown-seconds]");
    const targetTime = new Date(target).getTime();

    if (
      Number.isNaN(targetTime) ||
      !daysNode ||
      !hoursNode ||
      !minutesNode ||
      !secondsNode
    ) {
      return;
    }

    const render = () => {
      const distance = Math.max(targetTime - Date.now(), 0);
      const totalSeconds = Math.floor(distance / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      daysNode.textContent = String(days).padStart(2, "0");
      hoursNode.textContent = String(hours).padStart(2, "0");
      minutesNode.textContent = String(minutes).padStart(2, "0");
      secondsNode.textContent = String(seconds).padStart(2, "0");
    };

    render();
    window.setInterval(render, 1000);
  });

  const productSections = document.querySelectorAll("[data-product-section]");

  productSections.forEach((section) => {
    const variantScript = section.parentElement?.querySelector("[data-product-variants]");
    const variantInput = section.querySelector('[name="id"]');
    const priceNode = section.querySelector("[data-product-price]");
    const compareNode = section.querySelector("[data-product-compare]");
    const statusNode = section.querySelector("[data-product-status]");
    const inventoryNode = section.querySelector("[data-product-inventory]");
    const submitButton = section.querySelector("[data-product-submit]");
    const fallbackLink = section.querySelector("[data-product-fallback]");
    const productForm = section.querySelector(".dc-product-form");
    const checkoutButtons = Array.from(document.querySelectorAll("[data-product-checkout]"))
      .filter((button) => button.form === productForm);

    if (!variantScript || !variantInput || !priceNode || !statusNode) {
      return;
    }

    let variants = [];

    try {
      variants = JSON.parse(variantScript.textContent || "[]");
    } catch (_error) {
      variants = [];
    }

    if (!variants.length) {
      return;
    }

    const currencyCode = section.getAttribute("data-currency-code") || "USD";
    const availableLabel = section.getAttribute("data-available-label") || "Available";
    const unavailableLabel = section.getAttribute("data-unavailable-label") || "Unavailable";
    const primaryCtaLabel = section.getAttribute("data-primary-cta-label") || "Add to cart";
    const unavailableCtaLabel = section.getAttribute("data-unavailable-cta-label") || "Coming soon";
    const forcePurchase = section.getAttribute("data-force-purchase") === "true";
    const currencyFormatter = new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: currencyCode,
    });

    const formatMoney = (cents) => currencyFormatter.format((cents || 0) / 100);

    let inventoryRefreshInFlight = false;
    const refreshInventory = async () => {
      if (!inventoryNode || document.visibilityState !== "visible" || inventoryRefreshInFlight) return;

      const shopifySection = section.closest('[id^="shopify-section-"]');
      const sectionId = shopifySection?.id.replace(/^shopify-section-/, "");
      if (!sectionId || !variantInput.value) return;

      const refreshUrl = new URL(window.location.pathname, window.location.origin);
      const currentQuery = new URLSearchParams(window.location.search);
      currentQuery.forEach((value, key) => {
        if (key !== "sections" && key !== "section_id" && key !== "variant") {
          refreshUrl.searchParams.set(key, value);
        }
      });
      refreshUrl.searchParams.set("variant", variantInput.value);
      refreshUrl.searchParams.set("sections", sectionId);
      refreshUrl.searchParams.set("_inventory_refresh", String(Date.now()));

      inventoryRefreshInFlight = true;
      try {
        const response = await fetch(refreshUrl.toString(), {
          credentials: "same-origin",
          cache: "no-store",
          headers: { Accept: "application/json" },
        });
        if (!response.ok) return;

        const renderedSections = await response.json();
        const renderedSection = renderedSections[sectionId];
        if (typeof renderedSection !== "string") return;

        const refreshedDocument = new DOMParser().parseFromString(renderedSection, "text/html");
        const refreshedVariantsScript = refreshedDocument.querySelector("[data-product-variants]");
        if (!refreshedVariantsScript) return;

        const refreshedVariants = JSON.parse(refreshedVariantsScript.textContent || "[]");
        if (!Array.isArray(refreshedVariants) || !refreshedVariants.length) return;

        variants = refreshedVariants;
        renderVariant();
      } catch (_error) {
        // Keep the last known quantity visible if the refresh request fails.
      } finally {
        inventoryRefreshInFlight = false;
      }
    };

    const renderVariant = () => {
      const selectedId = Number(variantInput.value);
      const variant = variants.find((item) => Number(item.id) === selectedId);

      if (!variant) {
        return;
      }

      priceNode.textContent = formatMoney(variant.price);

      if (compareNode) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareNode.textContent = formatMoney(variant.compare_at_price);
          compareNode.classList.remove("dc-is-hidden");
        } else {
          compareNode.textContent = "";
          compareNode.classList.add("dc-is-hidden");
        }
      }

      const available = forcePurchase || Boolean(variant.available);
      statusNode.textContent = available ? availableLabel : unavailableLabel;

      if (inventoryNode) {
        const inventoryCount = Number(variant.inventory_quantity);
        const inventoryTracked = Boolean(variant.inventory_management);
        if (inventoryTracked && Number.isFinite(inventoryCount) && inventoryCount > 0) {
          inventoryNode.textContent = inventoryCount <= 10
            ? `Only ${inventoryCount} available.`
            : `${inventoryCount} available.`;
          inventoryNode.classList.remove("dc-is-hidden");
        } else {
          inventoryNode.textContent = "";
          inventoryNode.classList.add("dc-is-hidden");
        }
      }

      if (submitButton) {
        submitButton.textContent = primaryCtaLabel;
        submitButton.classList.toggle("dc-is-hidden", !available);
      }

      checkoutButtons.forEach((button) => {
        const canCheckout = available && Boolean(submitButton);
        button.disabled = !canCheckout;
        button.classList.toggle("dc-button--disabled", !canCheckout);
        button.textContent = canCheckout ? button.dataset.purchaseLabel : unavailableCtaLabel;
      });

      if (fallbackLink) {
        fallbackLink.textContent = unavailableCtaLabel;
        fallbackLink.classList.toggle("dc-is-hidden", available);
      }
    };

    if (variantInput instanceof HTMLSelectElement) {
      variantInput.addEventListener("change", renderVariant);
    }
    renderVariant();
    refreshInventory();
    window.setInterval(refreshInventory, 15000);
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") refreshInventory();
    });
  });

  if (window.location.pathname === "/products/double-cup-tumbler-20oz-1") {
    const signatureProductSection = document.querySelector("[data-product-section]");
    const signatureSubmitButton = signatureProductSection?.querySelector("[data-product-submit]");
    const signatureFallbackLink = signatureProductSection?.querySelector("[data-product-fallback]");
    const signatureStatusNode = signatureProductSection?.querySelector("[data-product-status]");

    if (signatureSubmitButton) {
      signatureSubmitButton.textContent = signatureProductSection?.getAttribute("data-primary-cta-label") || "Get yours now";
      signatureSubmitButton.classList.remove("dc-is-hidden");
    }

    if (signatureFallbackLink) {
      signatureFallbackLink.classList.add("dc-is-hidden");
    }

    if (signatureStatusNode) {
      signatureStatusNode.textContent = signatureProductSection?.getAttribute("data-available-label") || "Get yours now";
    }
  }

  const addToCartTriggers = document.querySelectorAll('a[href="#add-to-cart"]');

  addToCartTriggers.forEach((trigger) => {
    trigger.addEventListener("click", (event) => {
      const submitButton = document.querySelector('button[data-product-submit]:not(.dc-is-hidden)');
      if (!submitButton) {
        return;
      }

      event.preventDefault();
      submitButton.click();
    });
  });

  const cartTimers = document.querySelectorAll("[data-cart-timer]");

  cartTimers.forEach((timer) => {
    const valueNode = timer.querySelector("[data-cart-timer-value]");
    if (!valueNode || typeof window.sessionStorage === "undefined") {
      return;
    }

    const durationSeconds = Number(timer.getAttribute("data-duration-seconds")) || 180;
    const expiredLabel = timer.getAttribute("data-timer-expired-label") || "Expired";
    const storageKey = "doublecup-cart-timer-deadline";
    const now = Date.now();
    const storedDeadline = Number(window.sessionStorage.getItem(storageKey) || "0");
    const deadline = storedDeadline > now ? storedDeadline : now + durationSeconds * 1000;

    window.sessionStorage.setItem(storageKey, String(deadline));

    const renderTimer = () => {
      const remaining = Math.max(deadline - Date.now(), 0);
      const totalSeconds = Math.floor(remaining / 1000);
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;

      if (remaining <= 0) {
        valueNode.textContent = expiredLabel;
        timer.classList.add("dc-cart-timer--expired");
        return;
      }

      valueNode.textContent = `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
    };

    renderTimer();
    window.setInterval(renderTimer, 1000);
  });

  const quantitySteppers = document.querySelectorAll("[data-quantity-stepper]");

  quantitySteppers.forEach((stepper) => {
    const input = stepper.querySelector("[data-quantity-input]");
    const decreaseButton = stepper.querySelector("[data-quantity-decrease]");
    const increaseButton = stepper.querySelector("[data-quantity-increase]");

    if (!input || !decreaseButton || !increaseButton) {
      return;
    }

    const min = Number(input.getAttribute("min")) || 1;
    const max = Number(input.getAttribute("max")) || 50;

    const clampValue = (value) => {
      if (Number.isNaN(value)) {
        return min;
      }

      return Math.min(Math.max(value, min), max);
    };

    const syncButtons = () => {
      const currentValue = clampValue(Number(input.value));
      input.value = String(currentValue);
      decreaseButton.disabled = currentValue <= min;
      increaseButton.disabled = currentValue >= max;
    };

    decreaseButton.addEventListener("click", () => {
      input.value = String(clampValue(Number(input.value) - 1));
      syncButtons();
    });

    increaseButton.addEventListener("click", () => {
      input.value = String(clampValue(Number(input.value) + 1));
      syncButtons();
    });

    input.addEventListener("input", syncButtons);
    input.addEventListener("blur", syncButtons);
    syncButtons();
  });

});
document.addEventListener("DOMContentLoaded", () => {
  let purchaseBars = [];
  const updateSupportClearance = () => {
    const clearance = purchaseBars.reduce((height, bar) => {
      const bounds = bar.getBoundingClientRect();
      const isFixed = getComputedStyle(bar).position === "fixed";
      return isFixed && bounds.height > 0 && bounds.top < window.innerHeight
        ? Math.max(height, Math.ceil(window.innerHeight - bounds.top) + 12)
        : height;
    }, 0);
    document.body.style.setProperty("--dc-support-clearance", `${clearance}px`);
  };
  const observer = new ResizeObserver(updateSupportClearance);
  const observePurchaseBars = () => {
    observer.disconnect();
    purchaseBars = [...document.querySelectorAll(".dc-clean-sticky, .dc-cart-sticky-checkout")];
    purchaseBars.forEach((bar) => observer.observe(bar));
    updateSupportClearance();
  };
  observePurchaseBars();
  window.addEventListener("resize", updateSupportClearance, { passive: true });
  document.addEventListener("shopify:section:load", observePurchaseBars);
  document.addEventListener("shopify:section:unload", observePurchaseBars);
});
